import { Link } from 'react-router-dom';
import './ProductCard.css';

export default function ProductCard({ product }) {
  const primaryImage = product.images?.find(i => i.isPrimary) || product.images?.[0];
  const hasDiscount = product.salePrice && product.salePrice < product.basePrice;

  return (
    <div className="product-card">
      <Link to={`/product/${product.slug}`} className="product-card-image">
        {primaryImage ? (
          <img src={primaryImage.imageUrl} alt={primaryImage.altText || product.name} />
        ) : (
          <div className="product-card-placeholder">No Image</div>
        )}
        {hasDiscount && (
          <span className="product-card-badge">
            {Math.round((1 - product.salePrice / product.basePrice) * 100)}% OFF
          </span>
        )}
      </Link>
      <div className="product-card-info">
        {product.brand && <span className="product-card-brand">{product.brand}</span>}
        <Link to={`/product/${product.slug}`} className="product-card-name">{product.name}</Link>
        <div className="product-card-price">
          {hasDiscount ? (
            <>
              <span className="price-sale">₹{product.salePrice}</span>
              <span className="price-original">₹{product.basePrice}</span>
            </>
          ) : (
            <span className="price-sale">₹{product.basePrice}</span>
          )}
        </div>
        {product.avgRating > 0 && (
          <div className="product-card-rating">
            {'★'.repeat(Math.round(product.avgRating))}{'☆'.repeat(5 - Math.round(product.avgRating))}
            <span>({product.reviewCount})</span>
          </div>
        )}
      </div>
    </div>
  );
}
